// src/pages/mission/Mission.constants.js
// Equipment data and configuration constants

export const EQUIPMENT = {
  weapons: [
    { 
      id: 'assault_rifle', 
      name: 'Assault Rifle', 
      damage: 25, 
      accuracy: 75, 
      icon: '🔫' 
    },
    { 
      id: 'shotgun', 
      name: 'Shotgun', 
      damage: 45, 
      accuracy: 55, 
      icon: '🔫' 
    },
    { 
      id: 'sniper', 
      name: 'Sniper Rifle', 
      damage: 65, 
      accuracy: 90, 
      icon: '🎯' 
    },
    { 
      id: 'smg', 
      name: 'SMG', 
      damage: 18, 
      accuracy: 70, 
      icon: '🔫' 
    }
  ],
  armor: [
    { 
      id: 'standard_vest', 
      name: 'Standard Vest', 
      defense: 20, 
      mobility: 80, 
      icon: '🛡️' 
    },
    { 
      id: 'heavy_armor', 
      name: 'Heavy Armor', 
      defense: 50, 
      mobility: 50, 
      icon: '🛡️' 
    },
    { 
      id: 'light_armor', 
      name: 'Light Armor', 
      defense: 10, 
      mobility: 100, 
      icon: '🛡️' 
    }
  ],
  utility: [
    { 
      id: 'medkit', 
      name: 'Medkit', 
      effect: 'Heal 50 HP', 
      icon: '💊' 
    },
    { 
      id: 'grenade', 
      name: 'Frag Grenade', 
      effect: 'AoE Damage', 
      icon: '💣' 
    },
    { 
      id: 'smoke', 
      name: 'Smoke Grenade', 
      effect: 'Concealment', 
      icon: '💨' 
    },
    { 
      id: 'flashbang', 
      name: 'Flashbang', 
      effect: 'Stun Enemies', 
      icon: '✨' 
    }
  ]
};

export const DEFAULT_LOADOUT = {
  weapon: 'assault_rifle',
  armor: 'standard_vest',
  utility: 'medkit'
};

export const DEMO_MISSION = {
  name: 'Operation Steel Rain',
  tier: 'campaign',
  location: 'Enemy Command Center',
  duration: 360,
  threatLevel: 9,
  description: 'Major assault on enemy headquarters. Full squad deployment required.',
  storyContext: 'Intelligence suggests the enemy commander is coordinating attacks from this facility.',
  objectives: [
    'Breach the command center',
    'Eliminate enemy leadership',
    'Extract mission-critical intel',
    'Minimize civilian casualties'
  ],
  risks: { casualty: 'Very High', successRate: 60 },
  rewards: {
    funds: 25000,
    intel: 100,
    supplies: 75,
    xp: 500
  }
};

export const DEMO_SQUAD = [
  { id: 1, name: 'Anderson', rank: 'Sergeant', health: 100, max_health: 100 },
  { id: 2, name: 'Brooks', rank: 'Corporal', health: 100, max_health: 100 },
  { id: 3, name: 'Carter', rank: 'Specialist', health: 95, max_health: 100 },
  { id: 4, name: 'Davis', rank: 'Private', health: 100, max_health: 100 }
];